// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gMVmYD4xMcxLi0JD1p2l{padding:0 3px}.oY5RpoS9D8gpNKKInwHG{white-space:nowrap;margin-top:-4px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `gMVmYD4xMcxLi0JD1p2l`,
	"link": `oY5RpoS9D8gpNKKInwHG`
};
export default ___CSS_LOADER_EXPORT___;
